function updateInventoryWidget(variantId) {
  const inventoryData =
  window.inventoryInfo?.[
    window.inventoryInfo?.product?.handle
  ]?.variantLocations;

  if (!inventoryData) return;

  const variantData = inventoryData.find(
    (v) => String(v.variant) === String(variantId)
  );

  if (!variantData) return;

  const list = document.querySelector(
    '#inventory-info-app .iia-list'
  );

  if (!list) return;

  list.innerHTML = '';

  const selectedLocation =
    document.getElementById('location-selector')?.value;

  const filteredLocations = selectedLocation
    ? variantData.inventoryLocations.filter(
        (loc) =>
          String(loc.location.id) ===
          String(selectedLocation)
      )
    : variantData.inventoryLocations;

  filteredLocations.forEach((locationData) => {
    const location = locationData.location;

    const item = document.createElement('div');

    item.className = `iia-list-item iia-id-${location.id}`;

    item.innerHTML = `
      <div class="iia-location-info">
        <div class="iia-title-text">
          <span class="iia-location">
            <img
              src="https://cdn.shopify.com/s/files/1/0767/1850/6292/files/home-07-stroke-rounded.svg?v=1778222144"
              width="20"
              height="20"
            >
            ${location.name}
          </span>

          <span class="iia-qty">
            ${locationData.quantity} available
          </span>
        </div>

        <div class="iia-address">
          ${location.address1 || ''}
          ${location.address2 ? location.address2 + ',' : ''}
          ${location.city || ''}
          ${location.province || ''}
          ${location.zip || ''}
        </div>
      </div>
    `;

    list.appendChild(item);
  });
}

const outOfStockProduct = function () {
  const variantSelector =
    document.querySelectorAll('.variant-selectors')[0];

  if (!variantSelector) return;

  const variantBlock =
    variantSelector.querySelectorAll('.variant-block')[1];

  if (!variantBlock) return;

  const variantsList =
    variantBlock.querySelectorAll(
      '.variants-option input'
    );

  console.log(variantsList);
};

const ProductForm = {
  product: null,
  form: null,
  variantOptions: null,
  addToCartButton: null,
  selectedVariant: null,
  buyButton: null,
  variantsData: null,
  sku: null,
  price: null,
  compare_price: null,
  discount: null,

  initForm(product) {
    this.product = product;

    this.form =
      product.querySelector('.product-form');

    this.variantOptions =
      this.product.querySelectorAll(
        '.variants-option input'
      );

    this.addToCartButton =
      product.querySelectorAll(
        '.product-actions .ajax-cart'
      );

    this.variantsData = JSON.parse(
      this.form.querySelector(
        "script[type='application/ld+json']"
      ).innerHTML
    );

    this.registerUiComp();

    Array.from(this.variantOptions).forEach((el) => {
      el.addEventListener(
        'change',
        this.updateVariant.bind(this)
      );
    });

    this.variantsLoad();

    this.disableProductVariant();
  },

  variantsLoad() {
    let selectedVariantId =
      window.location.search.includes('?variant=')
        ? window.location.search
            .match(/variant=\d+/)[0]
            .match(/\d+/)[0]
        : '';

    this.selectedVariant =
      this.variantsData.variants.find(
        (variant) =>
          variant.id == selectedVariantId
      ) ||
      this.variantsData.variants.find(
        (variant) => variant.available == true
      );

    if (this.selectedVariant == undefined) {
      console.log('null');

      outOfStockProduct();
    } else {
      console.log(
        this.variantsData,
        'variants data here',
        this.selectedVariant
      );

      var selectedVariantForSticky =
        this.selectedVariant.option1;

      var selectedStickyTrue =
        document.querySelector(
          ".variants-option option[selected='true']"
        );

      if (selectedStickyTrue) {
        selectedStickyTrue.removeAttribute(
          'selected'
        );
      }

      document
        .querySelector(
          `.variants-option option[data-value="${selectedVariantForSticky}"]`
        )
        ?.setAttribute('selected', 'true');

      const stickyCartForm =
        document.querySelector(
          '.sticky-cart-form'
        );

      if (stickyCartForm) {
        const stickyForm =
          stickyCartForm.closest('form');

        if (stickyForm) {
          const stickyIdInput =
            stickyForm.querySelector(
              "input[name='id']"
            );

          const stickySubmit =
            stickyForm.querySelector(
              "input[type='submit']"
            );

          if (stickyIdInput) {
            stickyIdInput.value =
              this.selectedVariant.id;
          }

          if (stickySubmit) {
            this.selectedVariant.available
              ? stickySubmit.removeAttribute(
                  'disabled'
                )
              : stickySubmit.setAttribute(
                  'disabled',
                  'true'
                );
          }
        }
      }

      if (this.addToCartButton?.[0]) {
        this.selectedVariant.available
          ? this.addToCartButton[0].removeAttribute(
              'disabled'
            )
          : this.addToCartButton[0].setAttribute(
              'disabled',
              'true'
            );
      }

      this.updateUi();

      this.form.querySelector(
        "input[name='id']"
      ).value = this.selectedVariant.id;

      const selectedLocation =
        document.getElementById(
          'location-selector'
        )?.value;

      if (selectedLocation) {
        updateInventoryWidget(
          this.selectedVariant.id
        );
      }
    }
  },

  updateVariant() {
    let selectedOptions = Array.from(
      this.variantOptions
    )
      .filter((el) => el.checked)
      .map((el) => el.value);

    let selectedVariantData =
      this.variantsData.variants.filter(
        (el) =>
          el.options.length ==
            selectedOptions.length &&
          el.options.every(
            (opt) =>
              selectedOptions.indexOf(opt) !== -1
          )
      );

    if (!selectedVariantData.length) return;

    let searchQuery = `?variant=${selectedVariantData[0].id}`;

    window.history.pushState(
      {},
      '',
      searchQuery
    );

    this.selectedVariant =
      selectedVariantData[0];

    this.variantsLoad();
  },

  updateUi() {
    if (this.sku) {
      this.sku.innerHTML =
        this.selectedVariant.sku;
    }

    if (this.price) {
      this.price.innerHTML =
        this.priceFormatter(
          Number(this.selectedVariant.price) /
            100
        );
    }

    if (this.compare_price) {
      this.compare_price.innerHTML =
        this.priceFormatter(
          Number(
            this.selectedVariant.compare_at_price
          ) / 100
        );
    }

    let discountVal =
      Number(
        this.selectedVariant.compare_at_price
      ) >
      Number(this.selectedVariant.price)
        ? ((Number(
            this.selectedVariant.compare_at_price
          ) -
            Number(
              this.selectedVariant.price
            )) /
            Number(
              this.selectedVariant
                .compare_at_price
            )) *
          100
        : '';

    if (this.discount && discountVal) {
      this.discount.innerText =
        this.discount.innerText.replace(
          /\d+/,
          discountVal.toFixed()
        );
    }
  },

  registerUiComp() {
    this.sku =
      this.product.querySelector(
        '.product-sku'
      );

    this.compare_price =
      this.product.querySelector(
        '.compare-price s'
      );

    this.price =
      this.product.querySelector(
        '.sale-price'
      );

    this.discount =
      this.product.querySelector(
        '.product-discount p'
      );
  },

  priceFormatter(amount) {
    let formatter = new Intl.NumberFormat(
      'en-IN',
      {
        style: 'currency',
        currency: Shopify.currency.active,
      }
    );

    return formatter.format(amount);
  },

  disableProductVariant() {
    const allVariantsData =
      this.variantsData.variants;

    console.log(
      allVariantsData,
      'data here'
    );

    allVariantsData.forEach((el) => {
      if (!el.available) {
        let elementToDisable =
          document.querySelector(
            `.variants-option input[value="${el.option1}"]`
          );

        if (!elementToDisable) return;

        let elementToDisableId =
          elementToDisable.getAttribute('id');

        let elementToDisableIdLabel =
          document.querySelector(
            `.variants-option label[for="${elementToDisableId}"]`
          );

        let stickyDisable =
          document.querySelector(
            `.variants-option option[data-value="${el.option1}"]`
          );

        elementToDisable.setAttribute(
          'disabled',
          'true'
        );

        elementToDisableIdLabel?.classList.add(
          'disableTrue'
        );

        stickyDisable?.setAttribute(
          'disabled',
          'disabled'
        );
      }
    });
  },
};

document
  .getElementById('location-selector')
  ?.addEventListener('change', (e) => {
    const inventoryWidget =
      document.getElementById(
        'inventory-info-app'
      );

    if (!inventoryWidget) return;

    if (!e.target.value) {
      inventoryWidget.style.display =
        'none';
      return;
    }

    inventoryWidget.style.display =
      'block';

    if (ProductForm.selectedVariant) {
      updateInventoryWidget(
        ProductForm.selectedVariant.id
      );
    }
  });

const inventoryWidget =
  document.getElementById(
    'inventory-info-app'
  );

if (inventoryWidget) {
  inventoryWidget.style.display = 'none';
}

function populateLocations() {
  const selector = document.getElementById(
    'location-selector'
  );

  if (!selector) return;

  const handle =
    window.inventoryInfo?.product?.handle;

  if (!handle) return;

  const inventoryData =
    window.inventoryInfo?.[handle]
      ?.variantLocations;

  if (!inventoryData) return;

  const locationsMap = new Map();

  inventoryData.forEach((variant) => {
    variant.inventoryLocations.forEach(
      (inv) => {
        const location = inv.location;

        if (
          location &&
          !locationsMap.has(location.id)
        ) {
          locationsMap.set(location.id, {
            id: location.id,
            name: location.name,
          });
        }
      }
    );
  });

  selector.innerHTML =
    '<option value="">Choose location</option>';

  locationsMap.forEach((location) => {
    const option =
      document.createElement('option');

    option.value = location.id;
    option.textContent = location.name;

    selector.appendChild(option);
  });
}

window.addEventListener('load', () => {
  setTimeout(() => {
    populateLocations();
  }, 1000);
});

let product =
  document.querySelector(
    '.product-container'
  );

product
  ? ProductForm.initForm(product)
  : '';